import { render, staticRenderFns } from "./RegisterOperator.vue?vue&type=template&id=1c508515&scoped=true"
import script from "./RegisterOperator.vue?vue&type=script&lang=js"
export * from "./RegisterOperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c508515",
  null
  
)

export default component.exports